import { useCallback, useState } from 'react';
import { ScheduleEditorData } from '../types';
import { clone } from 'lodash-es';

export type FieldMetadata = {
  error: boolean;
};

const useFieldMetadata = (initial: ScheduleEditorData) => {
  const [meta, setMeta] = useState<Record<keyof ScheduleEditorData, FieldMetadata>>(
    Object.keys(initial).reduce((acc, key) => {
      return {
        ...acc,
        [key]: {
          error: false,
        },
      };
    }, {} as Record<keyof ScheduleEditorData, FieldMetadata>),
  );

  return { meta, setMeta };
};

export const useScheduleFormState = (initial: ScheduleEditorData) => {
  const [state, setState] = useState(initial);
  const { meta, setMeta } = useFieldMetadata(initial);

  const setValue = useCallback(<K extends keyof ScheduleEditorData>(key: K, value: ScheduleEditorData[K]) => {
    setState(oldState => {
      const newState: ScheduleEditorData = clone(oldState);
      newState[key] = value;

      return newState;
    });
  }, []);

  const setErrorFlag = useCallback(
    <K extends keyof typeof meta>(key: K, error: boolean) => {
      setMeta(oldMeta => {
        const newMeta = clone(oldMeta);
        newMeta[key] = {
          ...clone(oldMeta[key]),
          error,
        };

        return newMeta;
      });
    },
    [setMeta],
  );

  return { state, setValue, meta, setErrorFlag };
};
